module.exports = __webpack_public_path__ + "img/betty-logo.6b13f5db.svg";